import { render, staticRenderFns } from "./rated.vue?vue&type=template&id=02ffadd7&scoped=true&"
import script from "./rated.vue?vue&type=script&lang=js&"
export * from "./rated.vue?vue&type=script&lang=js&"
import style0 from "./rated.vue?vue&type=style&index=0&id=02ffadd7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ffadd7",
  null
  
)

export default component.exports